/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Typography } from '@mui/material';
import { UseKeycloakCheckRole } from '@europrocurement/l2d-keycloak';

export interface ConditionalMessageProps {
    /**
     * Texte à afficher
     */
    text: string;
    /**
     * Type de message qui détermine le style
     */
    type?: 'warning' | 'error' | 'info';
    /**
     * Si true, affiche le message seulement aux utilisateurs internes (défaut: true)
     */
    internalUsersOnly?: boolean;
    /**
     * Styles personnalisés (optionnel)
     */
    sx?: any;
}

/**
 * Composant simple pour afficher des messages conditionnels selon le rôle utilisateur.
 * Par défaut, les messages ne sont visibles que pour les utilisateurs internes.
 */
const ConditionalMessage: React.FunctionComponent<ConditionalMessageProps> = function ({
    text,
    type = 'warning',
    internalUsersOnly = true,
    sx,
}) {
    const kcCheckRole = UseKeycloakCheckRole();
    const isInternalUser = kcCheckRole('realm:interne');

    // Si le message est réservé aux utilisateurs internes et que l'utilisateur n'est pas interne
    if (internalUsersOnly && !isInternalUser) {
        return null;
    }

    // Styles par défaut selon le type
    const getDefaultStyle = () => {
        const baseStyle = {
            fontSize: '11px',
            fontStyle: 'italic',
            lineHeight: '14px',
        };

        switch (type) {
            case 'error':
                return { ...baseStyle, color: 'error.main' };
            case 'warning':
                return { ...baseStyle, color: 'warning.main' };
            case 'info':
            default:
                return { ...baseStyle, color: 'info.main' };
        }
    };

    return (
        <Typography
            sx={{ ...getDefaultStyle(), ...sx }}
            component="span"
        >
            {text}
        </Typography>
    );
};

export default ConditionalMessage;
